import type {Optional} from '@yandex-delivery/types'
import {get, pipe, toDefaultZero, toNumber} from '@yandex-delivery/utils'

import type {CustomParcelSizes, ParcelDimensions, ParcelSize} from 'src/shared/types'

import {getHeight, getLength, getWeightGross, getWidth, toWeight} from './to-physical-dimensions'

export const getParcelHeight = (
  customSizes: CustomParcelSizes,
  dimensions: Optional<ParcelDimensions>,
  size: Optional<ParcelSize>,
) => {
  const dimensionHeight = getHeight(dimensions)

  if (dimensionHeight === 0) {
    const fallbackValue = pipe(customSizes, get('small.height'), toDefaultZero)
    const dimensionHeightFromCustomSizes = pipe(customSizes, get(`${size}.height`), toDefaultZero, toNumber)

    return dimensionHeightFromCustomSizes || fallbackValue
  }

  return toNumber(dimensionHeight)
}

export const getParcelLength = (
  customSizes: CustomParcelSizes,
  dimensions: Optional<ParcelDimensions>,
  size: Optional<ParcelSize>,
): number => {
  const dimensionLength = getLength(dimensions)

  if (dimensionLength === 0) {
    const fallbackValue = pipe(customSizes, get('small.length'), toDefaultZero)
    const dimensionLengthFromCustomSizes = pipe(customSizes, get(`${size}.length`), toDefaultZero, toNumber)

    return dimensionLengthFromCustomSizes || fallbackValue
  }

  return dimensionLength
}

export const getParcelWeight = (
  customSizes: CustomParcelSizes,
  dimensions: Optional<ParcelDimensions>,
  size: Optional<ParcelSize>,
) => {
  const dimensionWeight = getWeightGross(dimensions)

  if (dimensionWeight === 0) {
    const fallbackValue = pipe(customSizes, get('small.weight'), toDefaultZero)
    const dimensionWeightFromCustomSizes = pipe(customSizes, get(`${size}.weight`), toDefaultZero, toNumber)
    const weight = dimensionWeightFromCustomSizes || fallbackValue

    return toWeight(weight)
  }

  return dimensionWeight
}

export const getParcelWidth = (
  customSizes: CustomParcelSizes,
  dimensions: Optional<ParcelDimensions>,
  size: Optional<ParcelSize>,
): number => {
  const dimensionWidth = getWidth(dimensions)

  if (dimensionWidth === 0) {
    const fallbackValue = pipe(customSizes, get('small.width'), toDefaultZero)
    const dimensionWidthFromCustomSizes = pipe(customSizes, get(`${size}.width`), toDefaultZero, toNumber)

    return dimensionWidthFromCustomSizes || fallbackValue
  }

  return dimensionWidth
}
